### Weitergabe von Daten

Im Rahmen deiner Nutzung der Webseiten erhältst du unter Umständen Daten anderer Teilnehmer. Es ist dir nicht erlaubt, diese Daten weiterzugeben!

Insbesondere im Hinblick auf die [WhatsApp Nutzungsbedingungen](https://www.whatsapp.com/legal/?l=de#terms-of-service) empfehlen wir dringend, Telefonnummern anderer Teilnehmer nur nach ausdrücklicher Absprache mit ihnen in deinem Mobiltelefon-Adressbuch zu speichern, denn es wird vollständig an WhatsApp Inc. übermittelt. Gemäß deutscher Rechtsprechung benötigst du dafür die Erlaubnis jeder einzelnen Person in deinem Adressbuch.

### Nutzungsbedingungen

Die Nutzung dieser Webseite erfordert wie die Teilnahme an diesem Dienstzweig ein Verhalten, wie man es von einem Christen erwartet. Bitte denke daran, dass auch hier gesetzliche Regelungen bzgl. Haftung bei missbräuchlicher Nutzung bestehen.

Insbesondere darfst du diese Webseite nicht in missbräuchlicher Art und Weise nutzen. Du bist beispielsweise nicht berechtigt, in die Dienste einzugreifen oder in anderer Weise als über die von uns bereitgestellte Benutzeroberfläche und gemäß unseren Vorgaben auf die Dienste zuzugreifen.

Unsere Webseite ist auch für mobile Geräte geeignet. Bitte nutze diese Dienste nicht in einer Weise, die dich ablenkt und das Einhalten von Verkehrsregeln oder Sicherheitsvorschriften verhindert.

### Dein Konto

Du erstellst gerade ein Konto auf unserer Seite.

Bitte behandle dein Passwort vertraulich, um dein Konto und die Daten der anderen Teilnehmer zu schützen. Du bist für die Aktivitäten in und mit deinem Konto verantwortlich. Nutze das Passwort deines Kontos möglichst nicht auch für Angebote Dritter. Solltest du eine unerlaubte Nutzung deines Passworts oder deines Kontos bemerken, wende dich bitte umgehend an die unter Kontakt genannten Kontaktdaten.

### Datenschutzerklärung

Unter unten stehendem Link findest du unsere Datenschutzerklärung. Du kannst sie auch später jederzeit über das Menü erreichen.
